import { ChangeDetectionStrategy, Component, computed, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConfigService } from 'src/app/config.service';
import { LocalAuthService } from '../local-auth.service';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-not-allowed',
    imports: [],
    templateUrl: './not-allowed.component.html',
    styleUrl: './not-allowed.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotAllowedComponent implements OnInit {

  roles: string[] = []
  groupOperator: "and" | "or" = "or"

  

  currentUser = toSignal(this.auth.currentUser$)

  homeUrl = computed(() => {
    const user = this.currentUser()

    if (user?.roles.includes("fullsite")) {
      return this.config.baseUrl
    }
    else {
      return this.config.mcHost + '/missioncontrol'
    }

  })

  //this is primarily for the mc3 transition so people can clear out a login token that may be missing the fullsite role
  signOutUrl = this.config.mcHost + '/missioncontrol/upgrade/signout'

  constructor(
    private router: Router,
    private config: ConfigService,
    private auth: LocalAuthService
  ) { 
    this.roles = this.router.getCurrentNavigation()?.extras.state?.allowedRoles
    this.groupOperator = this.router.getCurrentNavigation()?.extras?.state?.groupOperator

    
  }

  ngOnInit() {
    
  }

}
